import React from 'react';
import styles from './SideBar.module.scss';
import clsx from 'clsx';
import OutsideClickHandler from 'react-outside-click-handler';

const SideBar = ({ show, onClose, children, width = 480, direction = 'right', className, isHome }) => {
  return (
    <>
      <div className={clsx(styles.sidebar, show && styles.sidebarActive, direction == 'right' && styles.sidebarRight, direction == 'left' && styles.sidebarLeft, isHome && styles.sidebarMobile)} style={{ width: `${width}px` }}>
        <div className={clsx(styles.close)} onClick={onClose}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
        <OutsideClickHandler onOutsideClick={onClose}>
          <div className={clsx(styles.content, className)}> {children} </div>
        </OutsideClickHandler>
      </div>
    </>
  );
};

export default SideBar;
